module.exports = __webpack_public_path__ + "static/media/fill-19.315e0bd3.svg";